export const getDataPageSix = (values) => {
    const hashMap = {
      documentoDeIdentificación: 78,
      declaraciónJuramentadaTerceros: 79,
      certificadoResidencia: 80,
      certificadoAfiliaciónEps: 81,
      soportesDeSocialización: 82,
      premios: 83,
      certificaciónEventos: 84,
      certificadoSociedadColectiva: 465,
      certificadoContratos: 466,
      otrosSoportesTrayectoria: 467,
      tarjetaProfesional: 468,
      certificadoRegistroObras: 464,
      soporteTrayectoriaGestor: 462,
      otrosSoportesGestor: 463,
      certificaciónDiscapacidad: 469,
      declaraciónJuramentadaAdultoMayor: 470,
      certificaciónSisben: 471,
      soporteListadoCensal: 472,
      certificaciónAgremiación: 473,
    }

    const fileList = []

    Object.keys(hashMap).forEach(key => {
      const fileTmp = values[key]
      if(fileTmp && fileTmp["0"]) {
        fileList.push({
          id: hashMap[key],
          file: fileTmp["0"]
        })
      }
    })
    
    return fileList
}